import { render, staticRenderFns } from "./PiutangDetail.vue?vue&type=template&id=9c81d05a&"
import script from "./PiutangDetail.vue?vue&type=script&lang=js&"
export * from "./PiutangDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports